import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Cartao, Titulo, TituloAcoes, Conteudo, Rotulo, ValorDestacado, Timestamp } from "../styles";
import { IconCheckCircunferenciaConclusao, IconClock } from "../../../icons/IconesSistema";
import { IconUser } from "../../../icons";
import { 
  RodapeFinalizacao,
  RodapeContainer,
  AvatarContainer,
  InfoContainer,
  NomeContainer,
  NomeProfissional,
  CodigoProfissional
} from "./styles";
import { comum } from "../../../../styles/Themes/light";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useAuth } from "../../../../contexts/UserContext";

const formatarDataRelativa = (data: string | Date | null | undefined): string => {
  if (!data) return "";
  try {
    const dataFormatada = new Date(data);
    if (Number.isNaN(dataFormatada.getTime())) return "";
    return formatDistanceToNow(dataFormatada, { 
      addSuffix: true, 
      locale: ptBR 
    });
  } catch (error) {
    return "";
  }
};

export default function ObservacoesFinalizacao({ demanda, loading = false }: any) {
  const { user } = useAuth();

  const historicoFinalizacao = (demanda as any)?.historico
    ?.filter((h: any) => {
      const acaoLower = h.acao?.toLowerCase() || '';
      return acaoLower.includes('demanda finalizada') || 
             acaoLower.includes('finalizou demanda com aceite') ||
             acaoLower.includes('finalizou demanda com recusa');
    })
    ?.sort((a: any, b: any) => {
      const dataA = new Date(a.criado || 0).getTime();
      const dataB = new Date(b.criado || 0).getTime();
      return dataB - dataA;
    })?.[0];
  
  const mensagem = demanda?.info_finalizacao || historicoFinalizacao?.justificativa || "--";
  
  const nomeOperador = historicoFinalizacao?.nome_responsavel || demanda?.nome_operador || demanda?.nomeOperador || "";
  const idOperador = historicoFinalizacao?.id_responsavel || demanda?.id_operador;
  const dataEnvio = historicoFinalizacao?.criado;
  const dataRelativa = formatarDataRelativa(dataEnvio);

  if (loading) {
    return (
      <Cartao>
        <Titulo>
          <Skeleton circle width={18} height={18} />
          <Skeleton width={200} height={18} />
          <div style={{ marginLeft: 'auto' }}>
            <Skeleton width={200} height={14} />
          </div>
        </Titulo>
        <Conteudo>
          <Skeleton width={180} height={14} style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height={60} borderRadius={6} />
        </Conteudo>
      </Cartao>
    );
  }

  const podeVerFinalizacao = user?.profile === 'admin' || 
                           user?.profile === 'operador' || 
                           (user?.profile === 'comum' && Number(user?.id) === demanda?.id_usuario);

  // Exibir se tiver permissão E (tiver mensagem OU tiver histórico de finalização)
  const temHistorico = !!historicoFinalizacao;
  const temMensagem = mensagem && mensagem !== "--";
  
  if (!podeVerFinalizacao || (!temMensagem && !temHistorico)) {
    return null;
  }

  const codigoFormatado = idOperador ? `P${idOperador}` : "";
  const temIdentificacao = nomeOperador || codigoFormatado;

  return (
    <Cartao>
      <Titulo>
        <IconCheckCircunferenciaConclusao size={18} color="#16a34a" />
        Finalização da demanda
        {dataRelativa && (
          <TituloAcoes>
            <Timestamp>
              <IconClock size={14} />
              {dataRelativa}
            </Timestamp>
          </TituloAcoes>
        )}
      </Titulo>
      <Conteudo>
        {temIdentificacao && (
          <RodapeFinalizacao>
            <RodapeContainer>
              <AvatarContainer>
                <IconUser color={comum.colors.primaryRed400} size={20} />
              </AvatarContainer>
              <InfoContainer>
                <NomeContainer>
                  {nomeOperador ? (
                    <>
                      <NomeProfissional>{nomeOperador}</NomeProfissional>
                      {codigoFormatado && <CodigoProfissional>{codigoFormatado}</CodigoProfissional>}
                    </>
                  ) : codigoFormatado ? (
                    <NomeProfissional>{codigoFormatado}</NomeProfissional>
                  ) : null}
                </NomeContainer>
              </InfoContainer>
            </RodapeContainer>
          </RodapeFinalizacao>
        )}

        <Rotulo>Mensagem da finalização:</Rotulo>
        <ValorDestacado>{mensagem}</ValorDestacado>
      </Conteudo>
    </Cartao>
  );
}

